"use client";

export function prefersModalIframeFullscreen() {
  if (typeof navigator === "undefined") return false;

  const ua = navigator.userAgent || "";
  return /iPhone/i.test(ua);
}
